import { Link } from "react-router-dom";
import { BRAND } from "../../lib/brand";

export const Wordmark = ({ compact = false, testId = "brand-wordmark" }) => (
  <Link to="/" data-testid={testId} className="group inline-flex items-center gap-2.5">
    <span className="relative flex h-8 w-8 items-center justify-center rounded-[6px] border border-elv-green/40 bg-elv-green/10">
      <span className="h-2 w-2 rounded-full bg-elv-green" style={{ animation: "pulse-ring 3s infinite" }} />
    </span>
    <span className="font-display text-[15px] font-semibold uppercase tracking-[0.26em] text-elv-text">
      {BRAND.wordmark.primary}
      <span className="text-elv-green"> {BRAND.wordmark.secondary}</span>
    </span>
    {!compact ? (
      <span className="hidden border-l border-elv-line pl-2.5 text-[10px] uppercase tracking-[0.2em] text-elv-dim lg:inline">
        Operating System
      </span>
    ) : null}
  </Link>
);

export default Wordmark;
